import * as React from "react";

export const EyeColorGene = (): React.ReactElement => (
  <svg
    width="327"
    height="307"
    viewBox="0 0 327 307"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4517 5.7287C34.8699 5.7287 38.4517 9.31041 38.4517 13.7287L38.4516 74.9287C38.4516 77.5461 37.1947 79.8699 35.2515 81.3294V84.528C37.1947 85.9875 38.4516 88.3113 38.4516 90.9287L38.4516 269.729C38.4516 274.147 34.8699 277.729 30.4517 277.729C26.0334 277.729 22.4517 274.147 22.4517 269.729L22.4517 90.9287C22.4517 88.1359 23.8828 85.6773 26.0517 84.2463V81.6111C23.8828 80.1801 22.4517 77.7215 22.4517 74.9287L22.4517 13.7287C22.4517 9.31042 26.0334 5.7287 30.4517 5.7287Z"
        fill="#F7FAFC"
      />
      <rect x="22.4517" y="28.9287" width="15.9997" height="8" fill="#E2E8F0" />
      <rect
        x="22.4517"
        y="40.5287"
        width="15.9997"
        height="20"
        fill="#E2E8F0"
      />
      <rect
        x="22.4517"
        y="66.1287"
        width="15.9997"
        height="3.2"
        fill="#E2E8F0"
      />
      <mask
        id="mask0_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="22"
        y="76"
        width="17"
        height="14"
      >
        <path
          d="M38.4515 76.1287C38.4515 78.4223 37.108 80.4499 35.0516 81.6771V84.1418C37.108 85.3689 38.4515 87.3966 38.4515 89.6902L22.4517 89.6902C22.4517 87.3966 23.7953 85.3689 25.8517 84.1418V81.6771C23.7953 80.45 22.4517 78.4224 22.4517 76.1287H38.4515Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask0_1168_39262)">
        <path
          d="M22.4517 76.9739H38.4514V88.9739H22.4517V76.9739Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="22.4517"
        y="100.929"
        width="15.9997"
        height="12"
        fill="#E2E8F0"
      />
      <rect x="22.4517" y="121.729" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="22.4517" y="132.529" width="16" height="20" fill="#E2E8F0" />
      <rect x="22.4517" y="158.129" width="16" height="20" fill="#E2E8F0" />
      <rect x="22.4517" y="182.529" width="16" height="8" fill="#E2E8F0" />
      <rect x="22.4517" y="192.129" width="16" height="8" fill="#E2E8F0" />
      <rect x="22.4517" y="215.329" width="16" height="4" fill="#E2E8F0" />
      <rect x="22.4517" y="229.729" width="16" height="8.8" fill="#E2E8F0" />
      <rect x="22.4517" y="242.129" width="16" height="3.2" fill="#E2E8F0" />
      <rect x="22.4517" y="248.129" width="16" height="16" fill="#E2E8F0" />
      <rect x="22.4517" y="265.729" width="16" height="4" fill="#E2E8F0" />
    </g>
    <g clipPath="url(#clip1_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.4515 5.7287C58.8698 5.7287 62.4515 9.31041 62.4515 13.7287L62.4515 74.9287C62.4515 77.5461 61.1946 79.8699 59.2514 81.3294V84.528C61.1946 85.9875 62.4515 88.3113 62.4515 90.9287L62.4515 269.729C62.4515 274.147 58.8698 277.729 54.4515 277.729C50.0333 277.729 46.4516 274.147 46.4516 269.729L46.4515 90.9287C46.4515 88.1359 47.8827 85.6773 50.0515 84.2463V81.6111C47.8826 80.1801 46.4515 77.7215 46.4515 74.9287L46.4516 13.7287C46.4516 9.31042 50.0333 5.7287 54.4515 5.7287Z"
        fill="#F7FAFC"
      />
      <rect x="46.4515" y="28.9287" width="15.9997" height="8" fill="#E2E8F0" />
      <rect
        x="46.4515"
        y="40.5287"
        width="15.9997"
        height="20"
        fill="#E2E8F0"
      />
      <rect
        x="46.4515"
        y="66.1287"
        width="15.9997"
        height="3.2"
        fill="#E2E8F0"
      />
      <mask
        id="mask1_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="46"
        y="76"
        width="17"
        height="14"
      >
        <path
          d="M62.4514 76.1287C62.4514 78.4223 61.1079 80.4499 59.0515 81.6771V84.1418C61.1079 85.3689 62.4514 87.3966 62.4514 89.6902L46.4516 89.6902C46.4516 87.3966 47.7951 85.3689 49.8516 84.1418V81.6771C47.7951 80.45 46.4515 78.4224 46.4515 76.1287H62.4514Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask1_1168_39262)">
        <path
          d="M46.4515 76.9739H62.4513V88.9739H46.4515V76.9739Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="46.4515"
        y="100.929"
        width="15.9997"
        height="12"
        fill="#E2E8F0"
      />
      <rect x="46.4515" y="121.729" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="46.4515" y="132.529" width="16" height="20" fill="#E2E8F0" />
      <rect x="46.4515" y="158.129" width="16" height="20" fill="#E2E8F0" />
      <rect x="46.4515" y="182.529" width="16" height="8" fill="#E2E8F0" />
      <rect x="46.4515" y="192.129" width="16" height="8" fill="#E2E8F0" />
      <rect x="46.4515" y="215.329" width="16" height="4" fill="#E2E8F0" />
      <rect x="46.4515" y="229.729" width="16" height="8.8" fill="#E2E8F0" />
      <rect x="46.4515" y="242.129" width="16" height="3.2" fill="#E2E8F0" />
      <rect x="46.4515" y="248.129" width="16" height="16" fill="#E2E8F0" />
      <rect x="46.4515" y="265.729" width="16" height="4" fill="#E2E8F0" />
    </g>
    <path
      d="M45.2572 288.757H41.5132V290.413C41.6732 290.237 41.8972 290.093 42.1852 289.981C42.4732 289.869 42.7852 289.813 43.1212 289.813C43.7212 289.813 44.2172 289.949 44.6092 290.221C45.0092 290.493 45.3012 290.845 45.4852 291.277C45.6692 291.709 45.7612 292.177 45.7612 292.681C45.7612 293.617 45.4972 294.361 44.9692 294.913C44.4412 295.457 43.6972 295.729 42.7372 295.729C42.0972 295.729 41.5412 295.621 41.0692 295.405C40.5972 295.181 40.2332 294.873 39.9772 294.481C39.7212 294.089 39.5812 293.637 39.5572 293.125H41.5612C41.6092 293.373 41.7252 293.581 41.9092 293.749C42.0932 293.909 42.3452 293.989 42.6652 293.989C43.0412 293.989 43.3212 293.869 43.5052 293.629C43.6892 293.389 43.7812 293.069 43.7812 292.669C43.7812 292.277 43.6852 291.977 43.4932 291.769C43.3012 291.561 43.0212 291.457 42.6532 291.457C42.3812 291.457 42.1572 291.525 41.9812 291.661C41.8052 291.789 41.6892 291.961 41.6332 292.177H39.6532V286.957H45.2572V288.757Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip2_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.9761 5.7287C95.3944 5.7287 98.9761 9.31041 98.9761 13.7287L98.976 98.1287C98.976 100.922 97.5449 103.38 95.3761 104.811V107.846C97.545 109.277 98.9761 111.736 98.9761 114.529L98.9761 257.729C98.9761 262.147 95.3944 265.729 90.9761 265.729C86.5578 265.729 82.9761 262.147 82.9761 257.729L82.9761 114.529C82.9761 111.736 84.4072 109.277 86.5761 107.846V104.811C84.4072 103.38 82.9761 100.922 82.9761 98.1287L82.9761 13.7287C82.9761 9.31042 86.5578 5.7287 90.9761 5.7287Z"
        fill="#F7FAFC"
      />
      <rect
        x="82.9761"
        y="18.5287"
        width="15.9997"
        height="7.2"
        fill="#E2E8F0"
      />
      <rect
        x="82.9761"
        y="33.7287"
        width="15.9997"
        height="20"
        fill="#E2E8F0"
      />
      <rect x="82.9761" y="68.9287" width="16" height="6.4" fill="#E2E8F0" />
      <mask
        id="mask2_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="82"
        y="97"
        width="17"
        height="18"
      >
        <path
          d="M98.9759 97.7287C98.9759 99.0817 97.6324 103.878 95.576 104.602V107.656C97.6324 108.38 98.9759 113.176 98.9759 114.529L82.9761 114.529C82.9761 113.176 84.3197 108.38 86.3761 107.656V104.602C84.3197 103.878 82.9761 99.0818 82.9761 97.7287H98.9759Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask2_1168_39262)">
        <path
          d="M82.9761 102.129H98.9761V110.129H82.9761V102.129Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="82.9761"
        y="83.3287"
        width="15.9997"
        height="11.6"
        fill="#E2E8F0"
      />
      <rect x="82.9761" y="115.729" width="15.9997" height="6" fill="#E2E8F0" />
      <rect x="82.9761" y="126.929" width="16" height="28" fill="#E2E8F0" />
      <rect x="82.9761" y="158.529" width="16" height="8.8" fill="#E2E8F0" />
      <rect x="82.9761" y="180.529" width="16" height="12" fill="#E2E8F0" />
      <rect x="82.9761" y="194.929" width="16" height="12.8" fill="#E2E8F0" />
      <rect x="82.9761" y="212.129" width="16" height="4" fill="#E2E8F0" />
      <rect x="82.9761" y="219.729" width="16" height="16" fill="#E2E8F0" />
      <rect x="82.9761" y="249.329" width="16" height="8" fill="#E2E8F0" />
    </g>
    <g clipPath="url(#clip3_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.976 5.7287C119.394 5.7287 122.976 9.31041 122.976 13.7287L122.976 98.1287C122.976 100.922 121.545 103.38 119.376 104.811V107.846C121.545 109.277 122.976 111.736 122.976 114.529L122.976 257.729C122.976 262.147 119.394 265.729 114.976 265.729C110.558 265.729 106.976 262.147 106.976 257.729L106.976 114.529C106.976 111.736 108.407 109.277 110.576 107.846V104.811C108.407 103.38 106.976 100.922 106.976 98.1287L106.976 13.7287C106.976 9.31042 110.558 5.7287 114.976 5.7287Z"
        fill="#F7FAFC"
      />
      <rect
        x="106.976"
        y="18.5287"
        width="15.9997"
        height="7.2"
        fill="#E2E8F0"
      />
      <rect
        x="106.976"
        y="33.7287"
        width="15.9997"
        height="20"
        fill="#E2E8F0"
      />
      <rect x="106.976" y="68.9287" width="16" height="6.4" fill="#E2E8F0" />
      <mask
        id="mask3_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="106"
        y="97"
        width="17"
        height="18"
      >
        <path
          d="M122.976 97.7287C122.976 99.0817 121.632 103.878 119.576 104.602V107.656C121.632 108.38 122.976 113.176 122.976 114.529L106.976 114.529C106.976 113.176 108.32 108.38 110.376 107.656V104.602C108.32 103.878 106.976 99.0818 106.976 97.7287H122.976Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask3_1168_39262)">
        <path
          d="M106.976 102.129H122.976V110.129H106.976V102.129Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="106.976"
        y="83.3287"
        width="15.9997"
        height="11.6"
        fill="#E2E8F0"
      />
      <rect x="106.976" y="115.729" width="15.9997" height="6" fill="#E2E8F0" />
      <rect x="106.976" y="126.929" width="16" height="28" fill="#E2E8F0" />
      <rect x="106.976" y="158.529" width="16" height="8.8" fill="#E2E8F0" />
      <rect x="106.976" y="180.529" width="16" height="12" fill="#E2E8F0" />
      <rect x="106.976" y="194.929" width="16" height="12.8" fill="#E2E8F0" />
      <rect x="106.976" y="212.129" width="16" height="4" fill="#E2E8F0" />
      <rect x="106.976" y="219.729" width="16" height="16" fill="#E2E8F0" />
      <rect x="106.976" y="249.329" width="16" height="8" fill="#E2E8F0" />
    </g>
    <path
      d="M104.028 277.333C103.964 277.037 103.852 276.817 103.692 276.673C103.532 276.521 103.304 276.445 103.008 276.445C102.552 276.445 102.224 276.645 102.024 277.045C101.824 277.437 101.72 278.061 101.712 278.917C101.888 278.637 102.14 278.417 102.468 278.257C102.804 278.097 103.172 278.017 103.572 278.017C104.356 278.017 104.984 278.265 105.456 278.761C105.936 279.257 106.176 279.949 106.176 280.837C106.176 281.421 106.056 281.933 105.816 282.373C105.584 282.813 105.24 283.157 104.784 283.405C104.336 283.653 103.804 283.777 103.188 283.777C101.956 283.777 101.1 283.393 100.62 282.625C100.14 281.849 99.8996 280.737 99.8996 279.289C99.8996 277.769 100.152 276.641 100.656 275.905C101.168 275.161 101.984 274.789 103.104 274.789C103.704 274.789 104.208 274.909 104.616 275.149C105.032 275.381 105.344 275.689 105.552 276.073C105.768 276.457 105.896 276.877 105.936 277.333H104.028ZM103.08 279.637C102.736 279.637 102.448 279.741 102.216 279.949C101.992 280.149 101.88 280.437 101.88 280.813C101.88 281.197 101.984 281.497 102.192 281.713C102.408 281.929 102.712 282.037 103.104 282.037C103.456 282.037 103.732 281.933 103.932 281.725C104.14 281.509 104.244 281.217 104.244 280.849C104.244 280.473 104.144 280.177 103.944 279.961C103.744 279.745 103.456 279.637 103.08 279.637Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip4_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M151.5 5.7287C155.919 5.7287 159.5 9.31041 159.5 13.7287L159.5 77.7287C159.5 82.147 155.919 85.7287 151.5 85.7287C147.082 85.7287 143.5 82.147 143.5 77.7287L143.501 13.7287C143.501 9.31041 147.082 5.7287 151.5 5.7287ZM151.501 85.7287C155.919 85.7287 159.501 89.3104 159.501 93.7287L159.501 193.729C159.501 198.147 155.92 201.729 151.501 201.729C147.083 201.729 143.501 198.147 143.501 193.729L143.501 93.7287C143.501 89.3104 147.083 85.7287 151.501 85.7287Z"
        fill="#F7FAFC"
      />
      <rect x="143.5" y="13.3287" width="15.9997" height="5.2" fill="#E2E8F0" />
      <rect x="143.5" y="26.9287" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="143.5" y="34.5287" width="16" height="20" fill="#E2E8F0" />
      <mask
        id="mask4_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="143"
        y="77"
        width="17"
        height="19"
      >
        <path
          d="M159.5 77.3287C159.5 78.6817 158.157 83.4778 156.1 84.2017V87.2557C158.157 87.9795 159.5 93.8757 159.5 95.2287L143.5 95.2287C143.5 93.8757 144.844 87.9795 146.901 87.2556V84.2017C144.844 83.4779 143.5 78.6817 143.5 77.3287H159.5Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask4_1168_39262)">
        <path d="M143.5 81.7287H159.5V89.7287H143.5V81.7287Z" fill="#EDF2F7" />
      </g>
      <rect
        x="143.5"
        y="58.1287"
        width="15.9997"
        height="11.6"
        fill="#E2E8F0"
      />
      <path
        d="M143.5 78.7287H159.5C159.5 80.9378 157.709 82.7287 155.5 82.7287H147.5C145.291 82.7287 143.5 80.9378 143.5 78.7287Z"
        fill="#E2E8F0"
      />
      <path
        d="M143.501 94.7287C143.501 90.3104 147.083 86.7287 151.501 86.7287C155.919 86.7287 159.501 90.3104 159.501 94.7287V96.7287H143.501V94.7287Z"
        fill="#E2E8F0"
      />
      <rect x="143.5" y="108.129" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="143.5" y="115.729" width="16" height="4" fill="#E2E8F0" />
      <rect x="143.5" y="124.129" width="16" height="16.8" fill="#E2E8F0" />
      <rect x="143.5" y="145.329" width="16" height="6.8" fill="#E2E8F0" />
      <rect x="143.5" y="153.729" width="16" height="6.8" fill="#E2E8F0" />
      <rect x="143.5" y="165.729" width="16" height="5.2" fill="#E2E8F0" />
      <rect x="143.5" y="184.529" width="16" height="8" fill="#E2E8F0" />
    </g>
    <g clipPath="url(#clip5_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M175.5 5.7287C179.919 5.7287 183.5 9.31041 183.5 13.7287L183.5 77.7287C183.5 82.147 179.919 85.7287 175.5 85.7287C171.082 85.7287 167.5 82.147 167.5 77.7287L167.5 13.7287C167.5 9.31041 171.082 5.7287 175.5 5.7287ZM175.501 85.7287C179.919 85.7287 183.501 89.3104 183.501 93.7287L183.501 193.729C183.501 198.147 179.919 201.729 175.501 201.729C171.083 201.729 167.501 198.147 167.501 193.729L167.501 93.7287C167.501 89.3104 171.083 85.7287 175.501 85.7287Z"
        fill="#F7FAFC"
      />
      <rect x="167.5" y="13.3287" width="15.9997" height="5.2" fill="#E2E8F0" />
      <rect x="167.5" y="26.9287" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="167.5" y="34.5287" width="16" height="20" fill="#E2E8F0" />
      <mask
        id="mask5_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="167"
        y="77"
        width="17"
        height="19"
      >
        <path
          d="M183.5 77.3287C183.5 78.6817 182.157 83.4778 180.1 84.2017V87.2557C182.157 87.9795 183.5 93.8757 183.5 95.2287L167.5 95.2287C167.5 93.8757 168.844 87.9795 170.9 87.2556V84.2017C168.844 83.4779 167.5 78.6817 167.5 77.3287H183.5Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask5_1168_39262)">
        <path d="M167.5 81.7287H183.5V89.7287H167.5V81.7287Z" fill="#EDF2F7" />
      </g>
      <rect
        x="167.5"
        y="58.1287"
        width="15.9997"
        height="11.6"
        fill="#E2E8F0"
      />
      <path
        d="M167.5 78.7287H183.5C183.5 80.9378 181.709 82.7287 179.5 82.7287H171.5C169.291 82.7287 167.5 80.9378 167.5 78.7287Z"
        fill="#E2E8F0"
      />
      <path
        d="M167.501 94.7287C167.501 90.3104 171.083 86.7287 175.501 86.7287C179.919 86.7287 183.501 90.3104 183.501 94.7287V96.7287H167.501V94.7287Z"
        fill="#E2E8F0"
      />
      <rect x="167.5" y="108.129" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="167.5" y="115.729" width="16" height="4" fill="#E2E8F0" />
      <rect x="167.5" y="124.129" width="16" height="16.8" fill="#E2E8F0" />
      <rect x="167.5" y="145.329" width="16" height="6.8" fill="#E2E8F0" />
      <rect x="167.5" y="153.729" width="16" height="6.8" fill="#E2E8F0" />
      <rect x="167.5" y="165.729" width="16" height="5.2" fill="#E2E8F0" />
      <rect x="167.5" y="184.529" width="16" height="8" fill="#E2E8F0" />
    </g>
    <path
      d="M159.313 213.277V211.369H162.637V220.129H160.501V213.277H159.313ZM163.824 213.277V211.369H167.148V220.129H165.012V213.277H163.824Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip6_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.025 5.7287C216.443 5.7287 220.025 9.31042 220.025 13.7287L220.025 25.7287C220.025 30.147 216.443 33.7287 212.025 33.7287C207.607 33.7287 204.025 30.147 204.025 25.7287L204.025 13.7287C204.025 9.31042 207.607 5.7287 212.025 5.7287ZM212.025 33.7287C216.443 33.7287 220.025 37.3104 220.025 41.7287L220.025 66.5287V72.9287L220.025 149.729C220.025 154.147 216.443 157.729 212.025 157.729C207.607 157.729 204.025 154.147 204.025 149.729L204.025 72.9287V66.5287L204.025 41.7287C204.025 37.3104 207.607 33.7287 212.025 33.7287Z"
        fill="#F7FAFC"
      />
      <rect
        x="204.025"
        y="14.9287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <rect
        x="204.025"
        y="16.5287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <path
        d="M204.025 49.3287H220.025V61.3287H204.025V49.3287Z"
        fill="#E2E8F0"
      />
      <path
        d="M204.025 70.5287H220.025V89.7287H204.025V70.5287Z"
        fill="#E2E8F0"
      />
      <rect
        x="204.025"
        y="102.529"
        width="15.9997"
        height="7.6"
        fill="#E2E8F0"
      />
      <rect x="204.025" y="114.929" width="16" height="6" fill="#E2E8F0" />
      <rect x="204.025" y="128.129" width="16" height="12.4" fill="#E2E8F0" />
      <rect x="204.025" y="146.929" width="16" height="4.8" fill="#E2E8F0" />
      <mask
        id="mask6_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="204"
        y="5"
        width="17"
        height="10"
      >
        <rect
          x="204.025"
          y="5.7287"
          width="15.9997"
          height="9.2"
          rx="4.6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask6_1168_39262)">
        <rect
          width="18.2409"
          height="18.3499"
          transform="translate(199.001 11.1974) rotate(-42.4793)"
          fill="#E2E8F0"
        />
        <line
          x1="213.374"
          y1="22.9165"
          x2="200.982"
          y2="9.38305"
          stroke="#CBD5E0"
        />
        <line
          x1="215.125"
          y1="21.3136"
          x2="202.733"
          y2="7.78015"
          stroke="#CBD5E0"
        />
        <line
          x1="216.875"
          y1="19.7108"
          x2="204.483"
          y2="6.1773"
          stroke="#CBD5E0"
        />
        <line
          x1="218.626"
          y1="18.1079"
          x2="206.234"
          y2="4.57446"
          stroke="#CBD5E0"
        />
        <line
          x1="220.376"
          y1="16.505"
          x2="207.984"
          y2="2.97155"
          stroke="#CBD5E0"
        />
        <line
          x1="222.127"
          y1="14.9022"
          x2="209.735"
          y2="1.36871"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask7_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="204"
        y="17"
        width="17"
        height="16"
      >
        <rect
          x="204.025"
          y="17.7287"
          width="15.9997"
          height="14.8"
          rx="7.4"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask7_1168_39262)">
        <rect
          width="23.9517"
          height="25.051"
          transform="matrix(0.561672 -0.82736 0.494677 0.869077 199.001 26.5263)"
          fill="#E2E8F0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 213.45 45.2672)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 215.318 42.516)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 217.186 39.7648)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 219.053 37.0135)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 220.921 34.2624)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 222.789 31.5112)"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask8_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="204"
        y="29"
        width="17"
        height="10"
      >
        <path
          d="M220.025 29.3287C220.025 31.1327 218.681 30.5942 216.625 31.5594V35.6313C218.681 36.5965 220.025 37.1246 220.025 38.9287L204.025 38.9287C204.025 37.1246 205.368 36.5964 207.425 35.6313V31.5594C205.368 30.5943 204.025 31.1327 204.025 29.3287H220.025Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask8_1168_39262)">
        <path
          d="M204.025 29.3287H220.025V38.3953H204.025V29.3287Z"
          fill="#EDF2F7"
        />
      </g>
    </g>
    <g clipPath="url(#clip7_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M236.025 5.7287C240.443 5.7287 244.025 9.31042 244.025 13.7287L244.025 25.7287C244.025 30.147 240.443 33.7287 236.025 33.7287C231.606 33.7287 228.025 30.147 228.025 25.7287L228.025 13.7287C228.025 9.31042 231.607 5.7287 236.025 5.7287ZM236.025 33.7287C240.443 33.7287 244.025 37.3104 244.025 41.7287L244.025 66.5287V72.9287L244.025 149.729C244.025 154.147 240.443 157.729 236.025 157.729C231.607 157.729 228.025 154.147 228.025 149.729L228.025 72.9287V66.5287L228.025 41.7287C228.025 37.3104 231.607 33.7287 236.025 33.7287Z"
        fill="#F7FAFC"
      />
      <rect
        x="228.025"
        y="14.9287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <rect
        x="228.025"
        y="16.5287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <path
        d="M228.025 49.3287H244.025V61.3287H228.025V49.3287Z"
        fill="#E2E8F0"
      />
      <path
        d="M228.025 70.5287H244.025V89.7287H228.025V70.5287Z"
        fill="#E2E8F0"
      />
      <rect
        x="228.025"
        y="102.529"
        width="15.9997"
        height="7.6"
        fill="#E2E8F0"
      />
      <rect x="228.025" y="114.929" width="16" height="6" fill="#E2E8F0" />
      <rect x="228.025" y="128.129" width="16" height="12.4" fill="#E2E8F0" />
      <rect x="228.025" y="146.929" width="16" height="4.8" fill="#E2E8F0" />
      <mask
        id="mask9_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="228"
        y="5"
        width="17"
        height="10"
      >
        <rect
          x="228.025"
          y="5.7287"
          width="15.9997"
          height="9.2"
          rx="4.6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask9_1168_39262)">
        <rect
          width="18.2409"
          height="18.3499"
          transform="translate(223.001 11.1974) rotate(-42.4793)"
          fill="#E2E8F0"
        />
        <line
          x1="237.374"
          y1="22.9165"
          x2="224.982"
          y2="9.38305"
          stroke="#CBD5E0"
        />
        <line
          x1="239.125"
          y1="21.3136"
          x2="226.733"
          y2="7.78015"
          stroke="#CBD5E0"
        />
        <line
          x1="240.875"
          y1="19.7108"
          x2="228.483"
          y2="6.1773"
          stroke="#CBD5E0"
        />
        <line
          x1="242.626"
          y1="18.1079"
          x2="230.234"
          y2="4.57446"
          stroke="#CBD5E0"
        />
        <line
          x1="244.376"
          y1="16.505"
          x2="231.984"
          y2="2.97155"
          stroke="#CBD5E0"
        />
        <line
          x1="246.127"
          y1="14.9022"
          x2="233.735"
          y2="1.36871"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask10_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="228"
        y="17"
        width="17"
        height="16"
      >
        <rect
          x="228.025"
          y="17.7287"
          width="15.9997"
          height="14.8"
          rx="7.4"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask10_1168_39262)">
        <rect
          width="23.9517"
          height="25.051"
          transform="matrix(0.561672 -0.82736 0.494677 0.869077 223.001 26.5263)"
          fill="#E2E8F0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 237.45 45.2672)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 239.318 42.516)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 241.185 39.7648)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 243.053 37.0135)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 244.921 34.2624)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 246.789 31.5112)"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask11_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="228"
        y="29"
        width="17"
        height="10"
      >
        <path
          d="M244.025 29.3287C244.025 31.1327 242.681 30.5942 240.625 31.5594V35.6313C242.681 36.5965 244.025 37.1246 244.025 38.9287L228.025 38.9287C228.025 37.1246 229.368 36.5964 231.425 35.6313V31.5594C229.368 30.5943 228.025 31.1327 228.025 29.3287H244.025Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask11_1168_39262)">
        <path
          d="M228.025 29.3287H244.025V38.3953H228.025V29.3287Z"
          fill="#EDF2F7"
        />
      </g>
    </g>
    <path
      d="M218.032 168.877V166.969H221.356V175.729H219.22V168.877H218.032ZM222.808 174.169V172.513L226.6 167.089H228.892V172.393H229.876V174.169H228.892V175.729H226.84V174.169H222.808ZM226.984 169.345L224.968 172.393H226.984V169.345Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip8_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M272.549 5.7287C276.968 5.7287 280.549 9.31042 280.549 13.7287L280.549 25.7287C280.549 30.147 276.968 33.7287 272.549 33.7287C268.131 33.7287 264.549 30.147 264.549 25.7287L264.549 13.7287C264.549 9.31042 268.131 5.7287 272.549 5.7287ZM272.549 33.7287C276.968 33.7287 280.549 37.3104 280.549 41.7287L280.549 66.5287V72.9287L280.549 144.529C280.549 148.947 276.968 152.529 272.549 152.529C268.131 152.529 264.549 148.947 264.549 144.529L264.549 72.9287V66.5287L264.549 41.7287C264.549 37.3104 268.131 33.7287 272.549 33.7287Z"
        fill="#F7FAFC"
      />
      <rect
        x="264.549"
        y="14.9287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <rect
        x="264.549"
        y="16.5287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <path
        d="M264.549 46.1287H280.549V50.9287H264.549V46.1287Z"
        fill="#E2E8F0"
      />
      <path
        d="M264.549 57.3287H280.549V65.3287H264.549V57.3287Z"
        fill="#E2E8F0"
      />
      <path
        d="M264.549 70.9287H280.549V79.7287H264.549V70.9287Z"
        fill="#E2E8F0"
      />
      <path
        d="M264.549 82.5287H280.549V91.3287H264.549V82.5287Z"
        fill="#E2E8F0"
      />
      <rect
        x="264.549"
        y="102.529"
        width="15.9997"
        height="4.8"
        fill="#E2E8F0"
      />
      <rect x="264.549" y="112.929" width="16" height="6" fill="#E2E8F0" />
      <rect x="264.549" y="124.529" width="16" height="12.4" fill="#E2E8F0" />
      <rect x="264.549" y="143.329" width="16" height="3.2" fill="#E2E8F0" />
      <mask
        id="mask12_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="264"
        y="5"
        width="17"
        height="10"
      >
        <rect
          x="264.549"
          y="5.7287"
          width="15.9997"
          height="9.2"
          rx="4.6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask12_1168_39262)">
        <rect
          width="18.2409"
          height="18.3499"
          transform="translate(259.525 11.1974) rotate(-42.4793)"
          fill="#E2E8F0"
        />
        <line
          x1="273.899"
          y1="22.9165"
          x2="261.507"
          y2="9.38305"
          stroke="#CBD5E0"
        />
        <line
          x1="275.649"
          y1="21.3136"
          x2="263.257"
          y2="7.78015"
          stroke="#CBD5E0"
        />
        <line
          x1="277.4"
          y1="19.7108"
          x2="265.008"
          y2="6.1773"
          stroke="#CBD5E0"
        />
        <line
          x1="279.15"
          y1="18.1079"
          x2="266.758"
          y2="4.57446"
          stroke="#CBD5E0"
        />
        <line
          x1="280.901"
          y1="16.505"
          x2="268.509"
          y2="2.97155"
          stroke="#CBD5E0"
        />
        <line
          x1="282.651"
          y1="14.9022"
          x2="270.259"
          y2="1.36871"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask13_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="264"
        y="17"
        width="17"
        height="13"
      >
        <rect
          x="264.549"
          y="17.7287"
          width="15.9997"
          height="12"
          rx="6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask13_1168_39262)">
        <rect
          width="20.9559"
          height="21.5678"
          transform="matrix(0.641967 -0.766732 0.574567 0.818458 259.525 24.8619)"
          fill="#E2E8F0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 274.108 39.8974)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 275.922 37.7306)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 277.737 35.5638)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 279.551 33.397)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 281.365 31.2303)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 283.179 29.0635)"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask14_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="264"
        y="26"
        width="17"
        height="11"
      >
        <path
          d="M280.549 26.9287C280.549 28.7327 279.206 28.1942 277.149 29.1594V33.2313C279.206 34.1965 280.549 34.7247 280.549 36.5287L264.549 36.5287C264.549 34.7247 265.893 34.1965 267.949 33.2313V29.1595C265.893 28.1943 264.549 28.7328 264.549 26.9287H280.549Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask14_1168_39262)">
        <path
          d="M264.549 26.9287H280.549V35.9954H264.549V26.9287Z"
          fill="#EDF2F7"
        />
      </g>
    </g>
    <g clipPath="url(#clip9_1168_39262)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M296.549 5.7287C300.967 5.7287 304.549 9.31042 304.549 13.7287L304.549 25.7287C304.549 30.147 300.967 33.7287 296.549 33.7287C292.131 33.7287 288.549 30.147 288.549 25.7287L288.549 13.7287C288.549 9.31042 292.131 5.7287 296.549 5.7287ZM296.549 33.7287C300.967 33.7287 304.549 37.3104 304.549 41.7287L304.549 66.5287V72.9287L304.549 144.529C304.549 148.947 300.967 152.529 296.549 152.529C292.131 152.529 288.549 148.947 288.549 144.529L288.549 72.9287V66.5287L288.549 41.7287C288.549 37.3104 292.131 33.7287 296.549 33.7287Z"
        fill="#F7FAFC"
      />
      <rect
        x="288.549"
        y="14.9287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <rect
        x="288.549"
        y="16.5287"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <path
        d="M288.549 46.1287H304.549V50.9287H288.549V46.1287Z"
        fill="#E2E8F0"
      />
      <path
        d="M288.549 57.3287H304.549V65.3287H288.549V57.3287Z"
        fill="#E2E8F0"
      />
      <path
        d="M288.549 70.9287H304.549V79.7287H288.549V70.9287Z"
        fill="#E2E8F0"
      />
      <path
        d="M288.549 82.5287H304.549V91.3287H288.549V82.5287Z"
        fill="#E2E8F0"
      />
      <rect
        x="288.549"
        y="102.529"
        width="15.9997"
        height="4.8"
        fill="#E2E8F0"
      />
      <rect x="288.549" y="112.929" width="16" height="6" fill="#E2E8F0" />
      <rect x="288.549" y="124.529" width="16" height="12.4" fill="#E2E8F0" />
      <rect x="288.549" y="143.329" width="16" height="3.2" fill="#E2E8F0" />
      <mask
        id="mask15_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="288"
        y="5"
        width="17"
        height="10"
      >
        <rect
          x="288.549"
          y="5.7287"
          width="15.9997"
          height="9.2"
          rx="4.6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask15_1168_39262)">
        <rect
          width="18.2409"
          height="18.3499"
          transform="translate(283.525 11.1974) rotate(-42.4793)"
          fill="#E2E8F0"
        />
        <line
          x1="297.899"
          y1="22.9165"
          x2="285.507"
          y2="9.38305"
          stroke="#CBD5E0"
        />
        <line
          x1="299.649"
          y1="21.3136"
          x2="287.257"
          y2="7.78015"
          stroke="#CBD5E0"
        />
        <line
          x1="301.4"
          y1="19.7108"
          x2="289.008"
          y2="6.1773"
          stroke="#CBD5E0"
        />
        <line
          x1="303.15"
          y1="18.1079"
          x2="290.758"
          y2="4.57446"
          stroke="#CBD5E0"
        />
        <line
          x1="304.901"
          y1="16.505"
          x2="292.509"
          y2="2.97155"
          stroke="#CBD5E0"
        />
        <line
          x1="306.651"
          y1="14.9022"
          x2="294.259"
          y2="1.36871"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask16_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="288"
        y="17"
        width="17"
        height="13"
      >
        <rect
          x="288.549"
          y="17.7287"
          width="15.9997"
          height="12"
          rx="6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask16_1168_39262)">
        <rect
          width="20.9559"
          height="21.5678"
          transform="matrix(0.641967 -0.766732 0.574567 0.818458 283.525 24.8619)"
          fill="#E2E8F0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 298.108 39.8974)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 299.922 37.7306)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 301.737 35.5638)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 303.551 33.397)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 305.365 31.2303)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 307.179 29.0635)"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask17_1168_39262"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="288"
        y="26"
        width="17"
        height="11"
      >
        <path
          d="M304.549 26.9287C304.549 28.7327 303.206 28.1942 301.149 29.1594V33.2313C303.206 34.1965 304.549 34.7247 304.549 36.5287L288.549 36.5287C288.549 34.7247 289.893 34.1965 291.949 33.2313V29.1595C289.893 28.1943 288.549 28.7328 288.549 26.9287H304.549Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask17_1168_39262)">
        <path
          d="M288.549 26.9287H304.549V35.9954H288.549V26.9287Z"
          fill="#EDF2F7"
        />
      </g>
    </g>
    <path
      d="M278.715 163.677V161.769H282.039V170.529H279.903V163.677H278.715ZM289.611 163.557H285.867V165.213C286.027 165.037 286.251 164.893 286.539 164.781C286.827 164.669 287.139 164.613 287.475 164.613C288.075 164.613 288.571 164.749 288.963 165.021C289.363 165.293 289.655 165.645 289.839 166.077C290.023 166.509 290.115 166.977 290.115 167.481C290.115 168.417 289.851 169.161 289.323 169.713C288.795 170.257 288.051 170.529 287.091 170.529C286.451 170.529 285.895 170.421 285.423 170.205C284.951 169.981 284.587 169.673 284.331 169.281C284.075 168.889 283.935 168.437 283.911 167.925H285.915C285.963 168.173 286.079 168.381 286.263 168.549C286.447 168.709 286.699 168.789 287.019 168.789C287.395 168.789 287.675 168.669 287.859 168.429C288.043 168.189 288.135 167.869 288.135 167.469C288.135 167.077 288.039 166.777 287.847 166.569C287.655 166.361 287.375 166.257 287.007 166.257C286.735 166.257 286.511 166.325 286.335 166.461C286.159 166.589 286.043 166.761 285.987 166.977H284.007V161.757H289.611V163.557Z"
      fill="#4A5568"
    />
    <rect
      x="0.420776"
      y="23.4352"
      width="51.2776"
      height="51.2776"
      rx="25.6388"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M6.77328 53.144C6.25995 53.144 5.79995 53.0606 5.39328 52.894C4.98661 52.7273 4.65995 52.4806 4.41328 52.154C4.17328 51.8273 4.04661 51.434 4.03328 50.974H5.85328C5.87995 51.234 5.96995 51.434 6.12328 51.574C6.27661 51.7073 6.47661 51.774 6.72328 51.774C6.97661 51.774 7.17661 51.7173 7.32328 51.604C7.46995 51.484 7.54328 51.3206 7.54328 51.114C7.54328 50.9406 7.48328 50.7973 7.36328 50.684C7.24995 50.5706 7.10661 50.4773 6.93328 50.404C6.76661 50.3306 6.52661 50.2473 6.21328 50.154C5.75995 50.014 5.38995 49.874 5.10328 49.734C4.81661 49.594 4.56995 49.3873 4.36328 49.114C4.15661 48.8406 4.05328 48.484 4.05328 48.044C4.05328 47.3906 4.28995 46.8806 4.76328 46.514C5.23661 46.1406 5.85328 45.954 6.61328 45.954C7.38661 45.954 8.00995 46.1406 8.48328 46.514C8.95661 46.8806 9.20995 47.394 9.24328 48.054H7.39328C7.37995 47.8273 7.29661 47.6506 7.14328 47.524C6.98995 47.3906 6.79328 47.324 6.55328 47.324C6.34661 47.324 6.17995 47.3806 6.05328 47.494C5.92661 47.6006 5.86328 47.7573 5.86328 47.964C5.86328 48.1906 5.96995 48.3673 6.18328 48.494C6.39661 48.6206 6.72995 48.7573 7.18328 48.904C7.63661 49.0573 8.00328 49.204 8.28328 49.344C8.56995 49.484 8.81661 49.6873 9.02328 49.954C9.22995 50.2206 9.33328 50.564 9.33328 50.984C9.33328 51.384 9.22995 51.7473 9.02328 52.074C8.82328 52.4006 8.52995 52.6606 8.14328 52.854C7.75661 53.0473 7.29995 53.144 6.77328 53.144ZM12.0956 51.754H14.3356V53.074H10.3856V46.054H12.0956V51.754ZM14.8612 49.554C14.8612 48.8606 15.0113 48.244 15.3113 47.704C15.6113 47.1573 16.0279 46.734 16.5613 46.434C17.1013 46.1273 17.7113 45.974 18.3913 45.974C19.2246 45.974 19.9379 46.194 20.5313 46.634C21.1246 47.074 21.5213 47.674 21.7213 48.434H19.8413C19.7013 48.1406 19.5013 47.9173 19.2413 47.764C18.9879 47.6106 18.6979 47.534 18.3713 47.534C17.8446 47.534 17.4179 47.7173 17.0913 48.084C16.7646 48.4506 16.6013 48.9406 16.6013 49.554C16.6013 50.1673 16.7646 50.6573 17.0913 51.024C17.4179 51.3906 17.8446 51.574 18.3713 51.574C18.6979 51.574 18.9879 51.4973 19.2413 51.344C19.5013 51.1906 19.7013 50.9673 19.8413 50.674H21.7213C21.5213 51.434 21.1246 52.034 20.5313 52.474C19.9379 52.9073 19.2246 53.124 18.3913 53.124C17.7113 53.124 17.1013 52.974 16.5613 52.674C16.0279 52.3673 15.6113 51.944 15.3113 51.404C15.0113 50.864 14.8612 50.2473 14.8612 49.554ZM22.6384 51.774V50.394L25.7984 45.874H27.7084V50.294H28.5284V51.774H27.7084V53.074H25.9984V51.774H22.6384ZM26.1184 47.754L24.4384 50.294H26.1184V47.754ZM34.506 47.264H31.386V48.644C31.5193 48.4973 31.706 48.3773 31.946 48.284C32.186 48.1906 32.446 48.144 32.726 48.144C33.226 48.144 33.6393 48.2573 33.966 48.484C34.2993 48.7106 34.5427 49.004 34.696 49.364C34.8493 49.724 34.926 50.114 34.926 50.534C34.926 51.314 34.706 51.934 34.266 52.394C33.826 52.8473 33.206 53.074 32.406 53.074C31.8727 53.074 31.4093 52.984 31.016 52.804C30.6227 52.6173 30.3193 52.3606 30.106 52.034C29.8927 51.7073 29.776 51.3306 29.756 50.904H31.426C31.466 51.1106 31.5627 51.284 31.716 51.424C31.8693 51.5573 32.0793 51.624 32.346 51.624C32.6593 51.624 32.8927 51.524 33.046 51.324C33.1993 51.124 33.276 50.8573 33.276 50.524C33.276 50.1973 33.196 49.9473 33.036 49.774C32.876 49.6006 32.6427 49.514 32.336 49.514C32.1093 49.514 31.9227 49.5706 31.776 49.684C31.6293 49.7906 31.5327 49.934 31.486 50.114H29.836V45.764H34.506V47.264ZM40.4099 51.834H37.7899L37.3699 53.074H35.5799L38.1199 46.054H40.0999L42.6399 53.074H40.8299L40.4099 51.834ZM39.9699 50.514L39.0999 47.944L38.2399 50.514H39.9699ZM43.183 51.704C43.4096 51.524 43.513 51.4406 43.493 51.454C44.1463 50.914 44.6596 50.4706 45.033 50.124C45.413 49.7773 45.733 49.414 45.993 49.034C46.253 48.654 46.383 48.284 46.383 47.924C46.383 47.6506 46.3196 47.4373 46.193 47.284C46.0663 47.1306 45.8763 47.054 45.623 47.054C45.3696 47.054 45.1696 47.1506 45.023 47.344C44.883 47.5306 44.813 47.7973 44.813 48.144H43.163C43.1763 47.5773 43.2963 47.104 43.523 46.724C43.7563 46.344 44.0596 46.064 44.433 45.884C44.813 45.704 45.233 45.614 45.693 45.614C46.4863 45.614 47.083 45.8173 47.483 46.224C47.8896 46.6306 48.093 47.1606 48.093 47.814C48.093 48.5273 47.8496 49.1906 47.363 49.804C46.8763 50.4106 46.2563 51.004 45.503 51.584H48.203V52.974H43.183V51.704Z"
      fill="white"
    />
    <rect
      x="68.09"
      y="0.828857"
      width="31.9434"
      height="31.9434"
      rx="15.9717"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M75.5372 13.7806V20.8006H73.8272V13.7806H75.5372ZM80.3564 20.8006L78.8964 18.1506H78.4864V20.8006H76.7764V13.7806H79.6464C80.1997 13.7806 80.6697 13.8773 81.0564 14.0706C81.4497 14.2639 81.743 14.5306 81.9364 14.8706C82.1297 15.2039 82.2264 15.5773 82.2264 15.9906C82.2264 16.4573 82.093 16.8739 81.8264 17.2406C81.5664 17.6073 81.1797 17.8673 80.6664 18.0206L82.2864 20.8006H80.3564ZM78.4864 16.9406H79.5464C79.8597 16.9406 80.093 16.8639 80.2464 16.7106C80.4064 16.5573 80.4864 16.3406 80.4864 16.0606C80.4864 15.7939 80.4064 15.5839 80.2464 15.4306C80.093 15.2773 79.8597 15.2006 79.5464 15.2006H78.4864V16.9406ZM87.8698 13.7806V15.1506H85.0098V16.6306H87.1498V17.9606H85.0098V20.8006H83.2998V13.7806H87.8698ZM88.6386 19.5006V18.1206L91.7986 13.6006H93.7086V18.0206H94.5286V19.5006H93.7086V20.8006H91.9986V19.5006H88.6386ZM92.1186 15.4806L90.4386 18.0206H92.1186V15.4806Z"
      fill="white"
    />
    <rect
      x="129.455"
      y="106.747"
      width="30.2622"
      height="30.2622"
      rx="15.1311"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M140.686 118.858V120.228H138.826V125.878H137.116V120.228H135.256V118.858H140.686ZM147.564 118.858L145.134 123.558V125.878H143.424V123.558L140.994 118.858H142.934L144.294 121.798L145.644 118.858H147.564ZM151.833 125.878L150.373 123.228H149.963V125.878H148.253V118.858H151.123C151.676 118.858 152.146 118.954 152.533 119.148C152.926 119.341 153.22 119.608 153.413 119.948C153.606 120.281 153.703 120.654 153.703 121.068C153.703 121.534 153.57 121.951 153.303 122.318C153.043 122.684 152.656 122.944 152.143 123.098L153.763 125.878H151.833ZM149.963 122.018H151.023C151.336 122.018 151.57 121.941 151.723 121.788C151.883 121.634 151.963 121.418 151.963 121.138C151.963 120.871 151.883 120.661 151.723 120.508C151.57 120.354 151.336 120.278 151.023 120.278H149.963V122.018Z"
      fill="white"
    />
    <rect
      x="243.779"
      y="26.888"
      width="37.8278"
      height="30.2622"
      rx="15.1311"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M252.351 46.0891C251.691 46.0891 251.084 45.9358 250.531 45.6291C249.984 45.3224 249.547 44.8958 249.221 44.3491C248.901 43.7958 248.741 43.1758 248.741 42.4891C248.741 41.8024 248.901 41.1858 249.221 40.6391C249.547 40.0924 249.984 39.6658 250.531 39.3591C251.084 39.0524 251.691 38.8991 252.351 38.8991C253.011 38.8991 253.614 39.0524 254.161 39.3591C254.714 39.6658 255.147 40.0924 255.461 40.6391C255.781 41.1858 255.941 41.8024 255.941 42.4891C255.941 43.1758 255.781 43.7958 255.461 44.3491C255.141 44.8958 254.707 45.3224 254.161 45.6291C253.614 45.9358 253.011 46.0891 252.351 46.0891ZM252.351 44.5291C252.911 44.5291 253.357 44.3424 253.691 43.9691C254.031 43.5958 254.201 43.1024 254.201 42.4891C254.201 41.8691 254.031 41.3758 253.691 41.0091C253.357 40.6358 252.911 40.4491 252.351 40.4491C251.784 40.4491 251.331 40.6324 250.991 40.9991C250.657 41.3658 250.491 41.8624 250.491 42.4891C250.491 43.1091 250.657 43.6058 250.991 43.9791C251.331 44.3458 251.784 44.5291 252.351 44.5291ZM256.602 42.4991C256.602 41.8058 256.752 41.1891 257.052 40.6491C257.352 40.1024 257.769 39.6791 258.302 39.3791C258.842 39.0724 259.452 38.9191 260.132 38.9191C260.965 38.9191 261.679 39.1391 262.272 39.5791C262.865 40.0191 263.262 40.6191 263.462 41.3791H261.582C261.442 41.0858 261.242 40.8624 260.982 40.7091C260.729 40.5558 260.439 40.4791 260.112 40.4791C259.585 40.4791 259.159 40.6624 258.832 41.0291C258.505 41.3958 258.342 41.8858 258.342 42.4991C258.342 43.1124 258.505 43.6024 258.832 43.9691C259.159 44.3358 259.585 44.5191 260.112 44.5191C260.439 44.5191 260.729 44.4424 260.982 44.2891C261.242 44.1358 261.442 43.9124 261.582 43.6191H263.462C263.262 44.3791 262.865 44.9791 262.272 45.4191C261.679 45.8524 260.965 46.0691 260.132 46.0691C259.452 46.0691 258.842 45.9191 258.302 45.6191C257.769 45.3124 257.352 44.8891 257.052 44.3491C256.752 43.8091 256.602 43.1924 256.602 42.4991ZM268.879 44.7791H266.259L265.839 46.0191H264.049L266.589 38.9991H268.569L271.109 46.0191H269.299L268.879 44.7791ZM268.439 43.4591L267.569 40.8891L266.709 43.4591H268.439ZM271.652 44.6491C271.879 44.4691 271.982 44.3858 271.962 44.3991C272.616 43.8591 273.129 43.4158 273.502 43.0691C273.882 42.7224 274.202 42.3591 274.462 41.9791C274.722 41.5991 274.852 41.2291 274.852 40.8691C274.852 40.5958 274.789 40.3824 274.662 40.2291C274.536 40.0758 274.346 39.9991 274.092 39.9991C273.839 39.9991 273.639 40.0958 273.492 40.2891C273.352 40.4758 273.282 40.7424 273.282 41.0891H271.632C271.646 40.5224 271.766 40.0491 271.992 39.6691C272.226 39.2891 272.529 39.0091 272.902 38.8291C273.282 38.6491 273.702 38.5591 274.162 38.5591C274.956 38.5591 275.552 38.7624 275.952 39.1691C276.359 39.5758 276.562 40.1058 276.562 40.7591C276.562 41.4724 276.319 42.1358 275.832 42.7491C275.346 43.3558 274.726 43.9491 273.972 44.5291H276.672V45.9191H271.652V44.6491Z"
      fill="white"
    />
    <rect
      x="285.81"
      y="43.7003"
      width="41.1902"
      height="30.2622"
      rx="15.1311"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M296.816 55.8114V62.8314H295.106V59.9414H292.446V62.8314H290.736V55.8114H292.446V58.5614H295.106V55.8114H296.816ZM299.76 57.1814V58.6014H302.05V59.9214H299.76V61.4614H302.35V62.8314H298.05V55.8114H302.35V57.1814H299.76ZM307.04 62.8314L305.58 60.1814H305.17V62.8314H303.46V55.8114H306.33C306.884 55.8114 307.354 55.9081 307.74 56.1014C308.134 56.2948 308.427 56.5614 308.62 56.9014C308.814 57.2348 308.91 57.6081 308.91 58.0214C308.91 58.4881 308.777 58.9048 308.51 59.2714C308.25 59.6381 307.864 59.8981 307.35 60.0514L308.97 62.8314H307.04ZM305.17 58.9714H306.23C306.544 58.9714 306.777 58.8948 306.93 58.7414C307.09 58.5881 307.17 58.3714 307.17 58.0914C307.17 57.8248 307.09 57.6148 306.93 57.4614C306.777 57.3081 306.544 57.2314 306.23 57.2314H305.17V58.9714ZM309.694 59.3114C309.694 58.6181 309.844 58.0014 310.144 57.4614C310.444 56.9148 310.861 56.4914 311.394 56.1914C311.934 55.8848 312.544 55.7314 313.224 55.7314C314.057 55.7314 314.771 55.9514 315.364 56.3914C315.957 56.8314 316.354 57.4314 316.554 58.1914H314.674C314.534 57.8981 314.334 57.6748 314.074 57.5214C313.821 57.3681 313.531 57.2914 313.204 57.2914C312.677 57.2914 312.251 57.4748 311.924 57.8414C311.597 58.2081 311.434 58.6981 311.434 59.3114C311.434 59.9248 311.597 60.4148 311.924 60.7814C312.251 61.1481 312.677 61.3314 313.204 61.3314C313.531 61.3314 313.821 61.2548 314.074 61.1014C314.334 60.9481 314.534 60.7248 314.674 60.4314H316.554C316.354 61.1914 315.957 61.7914 315.364 62.2314C314.771 62.6648 314.057 62.8814 313.224 62.8814C312.544 62.8814 311.934 62.7314 311.394 62.4314C310.861 62.1248 310.444 61.7014 310.144 61.1614C309.844 60.6214 309.694 60.0048 309.694 59.3114ZM317.371 61.4614C317.598 61.2814 317.701 61.1981 317.681 61.2114C318.334 60.6714 318.848 60.2281 319.221 59.8814C319.601 59.5348 319.921 59.1714 320.181 58.7914C320.441 58.4114 320.571 58.0414 320.571 57.6814C320.571 57.4081 320.508 57.1948 320.381 57.0414C320.254 56.8881 320.064 56.8114 319.811 56.8114C319.558 56.8114 319.358 56.9081 319.211 57.1014C319.071 57.2881 319.001 57.5548 319.001 57.9014H317.351C317.364 57.3348 317.484 56.8614 317.711 56.4814C317.944 56.1014 318.248 55.8214 318.621 55.6414C319.001 55.4614 319.421 55.3714 319.881 55.3714C320.674 55.3714 321.271 55.5748 321.671 55.9814C322.078 56.3881 322.281 56.9181 322.281 57.5714C322.281 58.2848 322.038 58.9481 321.551 59.5614C321.064 60.1681 320.444 60.7614 319.691 61.3414H322.391V62.7314H317.371V61.4614Z"
      fill="white"
    />
    <rect
      x="176.53"
      y="93.2968"
      width="44.5527"
      height="30.2622"
      rx="15.1311"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M183.271 111.484C182.861 111.484 182.493 111.417 182.167 111.284C181.842 111.151 181.581 110.953 181.383 110.692C181.191 110.431 181.09 110.116 181.079 109.748H182.535C182.557 109.956 182.629 110.116 182.751 110.228C182.874 110.335 183.034 110.388 183.231 110.388C183.434 110.388 183.594 110.343 183.711 110.252C183.829 110.156 183.887 110.025 183.887 109.86C183.887 109.721 183.839 109.607 183.743 109.516C183.653 109.425 183.538 109.351 183.399 109.292C183.266 109.233 183.074 109.167 182.823 109.092C182.461 108.98 182.165 108.868 181.935 108.756C181.706 108.644 181.509 108.479 181.343 108.26C181.178 108.041 181.095 107.756 181.095 107.404C181.095 106.881 181.285 106.473 181.663 106.18C182.042 105.881 182.535 105.732 183.143 105.732C183.762 105.732 184.261 105.881 184.639 106.18C185.018 106.473 185.221 106.884 185.247 107.412H183.767C183.757 107.231 183.69 107.089 183.567 106.988C183.445 106.881 183.287 106.828 183.095 106.828C182.93 106.828 182.797 106.873 182.695 106.964C182.594 107.049 182.543 107.175 182.543 107.34C182.543 107.521 182.629 107.663 182.799 107.764C182.97 107.865 183.237 107.975 183.599 108.092C183.962 108.215 184.255 108.332 184.479 108.444C184.709 108.556 184.906 108.719 185.071 108.932C185.237 109.145 185.319 109.42 185.319 109.756C185.319 110.076 185.237 110.367 185.071 110.628C184.911 110.889 184.677 111.097 184.367 111.252C184.058 111.407 183.693 111.484 183.271 111.484ZM187.529 110.372H189.321V111.428H186.161V105.812H187.529V110.372ZM189.742 108.612C189.742 108.057 189.862 107.564 190.102 107.132C190.342 106.695 190.675 106.356 191.102 106.116C191.534 105.871 192.022 105.748 192.566 105.748C193.232 105.748 193.803 105.924 194.278 106.276C194.752 106.628 195.07 107.108 195.23 107.716H193.726C193.614 107.481 193.454 107.303 193.246 107.18C193.043 107.057 192.811 106.996 192.55 106.996C192.128 106.996 191.787 107.143 191.526 107.436C191.264 107.729 191.134 108.121 191.134 108.612C191.134 109.103 191.264 109.495 191.526 109.788C191.787 110.081 192.128 110.228 192.55 110.228C192.811 110.228 193.043 110.167 193.246 110.044C193.454 109.921 193.614 109.743 193.726 109.508H195.23C195.07 110.116 194.752 110.596 194.278 110.948C193.803 111.295 193.232 111.468 192.566 111.468C192.022 111.468 191.534 111.348 191.102 111.108C190.675 110.863 190.342 110.524 190.102 110.092C189.862 109.66 189.742 109.167 189.742 108.612ZM195.884 110.332C196.065 110.188 196.148 110.121 196.132 110.132C196.654 109.7 197.065 109.345 197.364 109.068C197.668 108.791 197.924 108.5 198.132 108.196C198.34 107.892 198.444 107.596 198.444 107.308C198.444 107.089 198.393 106.919 198.292 106.796C198.19 106.673 198.038 106.612 197.836 106.612C197.633 106.612 197.473 106.689 197.356 106.844C197.244 106.993 197.188 107.207 197.188 107.484H195.868C195.878 107.031 195.974 106.652 196.156 106.348C196.342 106.044 196.585 105.82 196.884 105.676C197.188 105.532 197.524 105.46 197.892 105.46C198.526 105.46 199.004 105.623 199.324 105.948C199.649 106.273 199.812 106.697 199.812 107.22C199.812 107.791 199.617 108.321 199.228 108.812C198.838 109.297 198.342 109.772 197.74 110.236H199.9V111.348H195.884V110.332ZM200.534 110.388V109.284L203.062 105.668H204.59V109.204H205.246V110.388H204.59V111.428H203.222V110.388H200.534ZM203.318 107.172L201.974 109.204H203.318V107.172ZM209.548 110.436H207.452L207.116 111.428H205.684L207.716 105.812H209.3L211.332 111.428H209.884L209.548 110.436ZM209.196 109.38L208.5 107.324L207.812 109.38H209.196ZM211.846 110.388V109.284L214.374 105.668H215.902V109.204H216.558V110.388H215.902V111.428H214.534V110.388H211.846ZM214.63 107.172L213.286 109.204H214.63V107.172Z"
      fill="white"
    />
    <rect
      x="228.648"
      y="93.2968"
      width="52.9589"
      height="30.2622"
      rx="15.1311"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M235.171 111.428L234.003 109.308H233.675V111.428H232.307V105.812H234.603C235.046 105.812 235.422 105.889 235.731 106.044C236.046 106.199 236.28 106.412 236.435 106.684C236.59 106.951 236.667 107.249 236.667 107.58C236.667 107.953 236.56 108.287 236.347 108.58C236.139 108.873 235.83 109.081 235.419 109.204L236.715 111.428H235.171ZM233.675 108.34H234.523C234.774 108.34 234.96 108.279 235.083 108.156C235.211 108.033 235.275 107.86 235.275 107.636C235.275 107.423 235.211 107.255 235.083 107.132C234.96 107.009 234.774 106.948 234.523 106.948H233.675V108.34ZM242.55 111.428H241.182L238.894 107.964V111.428H237.526V105.812H238.894L241.182 109.292V105.812H242.55V111.428ZM244.885 105.812V109.172C244.885 109.508 244.968 109.767 245.133 109.948C245.299 110.129 245.541 110.22 245.861 110.22C246.181 110.22 246.427 110.129 246.597 109.948C246.768 109.767 246.853 109.508 246.853 109.172V105.812H248.221V109.164C248.221 109.665 248.115 110.089 247.901 110.436C247.688 110.783 247.4 111.044 247.037 111.22C246.68 111.396 246.28 111.484 245.837 111.484C245.395 111.484 244.997 111.399 244.645 111.228C244.299 111.052 244.024 110.791 243.821 110.444C243.619 110.092 243.517 109.665 243.517 109.164V105.812H244.885ZM251.934 107.164C251.891 106.967 251.817 106.82 251.71 106.724C251.603 106.623 251.451 106.572 251.254 106.572C250.95 106.572 250.731 106.705 250.598 106.972C250.465 107.233 250.395 107.649 250.39 108.22C250.507 108.033 250.675 107.887 250.894 107.78C251.118 107.673 251.363 107.62 251.63 107.62C252.153 107.62 252.571 107.785 252.886 108.116C253.206 108.447 253.366 108.908 253.366 109.5C253.366 109.889 253.286 110.231 253.126 110.524C252.971 110.817 252.742 111.047 252.438 111.212C252.139 111.377 251.785 111.46 251.374 111.46C250.553 111.46 249.982 111.204 249.662 110.692C249.342 110.175 249.182 109.433 249.182 108.468C249.182 107.455 249.35 106.703 249.686 106.212C250.027 105.716 250.571 105.468 251.318 105.468C251.718 105.468 252.054 105.548 252.326 105.708C252.603 105.863 252.811 106.068 252.95 106.324C253.094 106.58 253.179 106.86 253.206 107.164H251.934ZM251.302 108.7C251.073 108.7 250.881 108.769 250.726 108.908C250.577 109.041 250.502 109.233 250.502 109.484C250.502 109.74 250.571 109.94 250.71 110.084C250.854 110.228 251.057 110.3 251.318 110.3C251.553 110.3 251.737 110.231 251.87 110.092C252.009 109.948 252.078 109.753 252.078 109.508C252.078 109.257 252.011 109.06 251.878 108.916C251.745 108.772 251.553 108.7 251.302 108.7ZM257.716 108.052V109.188H254.196V108.052H257.716ZM258.828 107.236C258.85 106.665 259.036 106.225 259.388 105.916C259.74 105.607 260.218 105.452 260.82 105.452C261.22 105.452 261.562 105.521 261.844 105.66C262.132 105.799 262.348 105.988 262.492 106.228C262.642 106.468 262.716 106.737 262.716 107.036C262.716 107.388 262.628 107.676 262.452 107.9C262.276 108.119 262.071 108.268 261.836 108.348V108.38C262.14 108.481 262.38 108.649 262.556 108.884C262.732 109.119 262.82 109.42 262.82 109.788C262.82 110.119 262.743 110.412 262.588 110.668C262.439 110.919 262.218 111.116 261.924 111.26C261.636 111.404 261.292 111.476 260.892 111.476C260.252 111.476 259.74 111.319 259.356 111.004C258.978 110.689 258.778 110.215 258.756 109.58H260.084C260.09 109.815 260.156 110.001 260.284 110.14C260.412 110.273 260.599 110.34 260.844 110.34C261.052 110.34 261.212 110.281 261.324 110.164C261.442 110.041 261.5 109.881 261.5 109.684C261.5 109.428 261.418 109.244 261.252 109.132C261.092 109.015 260.834 108.956 260.476 108.956H260.22V107.844H260.476C260.748 107.844 260.967 107.799 261.132 107.708C261.303 107.612 261.388 107.444 261.388 107.204C261.388 107.012 261.335 106.863 261.228 106.756C261.122 106.649 260.975 106.596 260.788 106.596C260.586 106.596 260.434 106.657 260.332 106.78C260.236 106.903 260.18 107.055 260.164 107.236H258.828ZM266.512 107.164C266.469 106.967 266.395 106.82 266.288 106.724C266.181 106.623 266.029 106.572 265.832 106.572C265.528 106.572 265.309 106.705 265.176 106.972C265.043 107.233 264.973 107.649 264.968 108.22C265.085 108.033 265.253 107.887 265.472 107.78C265.696 107.673 265.941 107.62 266.208 107.62C266.731 107.62 267.149 107.785 267.464 108.116C267.784 108.447 267.944 108.908 267.944 109.5C267.944 109.889 267.864 110.231 267.704 110.524C267.549 110.817 267.32 111.047 267.016 111.212C266.717 111.377 266.363 111.46 265.952 111.46C265.131 111.46 264.56 111.204 264.24 110.692C263.92 110.175 263.76 109.433 263.76 108.468C263.76 107.455 263.928 106.703 264.264 106.212C264.605 105.716 265.149 105.468 265.896 105.468C266.296 105.468 266.632 105.548 266.904 105.708C267.181 105.863 267.389 106.068 267.528 106.324C267.672 106.58 267.757 106.86 267.784 107.164H266.512ZM265.88 108.7C265.651 108.7 265.459 108.769 265.304 108.908C265.155 109.041 265.08 109.233 265.08 109.484C265.08 109.74 265.149 109.94 265.288 110.084C265.432 110.228 265.635 110.3 265.896 110.3C266.131 110.3 266.315 110.231 266.448 110.092C266.587 109.948 266.656 109.753 266.656 109.508C266.656 109.257 266.589 109.06 266.456 108.916C266.323 108.772 266.131 108.7 265.88 108.7ZM271.606 107.164C271.563 106.967 271.488 106.82 271.382 106.724C271.275 106.623 271.123 106.572 270.926 106.572C270.622 106.572 270.403 106.705 270.27 106.972C270.136 107.233 270.067 107.649 270.062 108.22C270.179 108.033 270.347 107.887 270.566 107.78C270.79 107.673 271.035 107.62 271.302 107.62C271.824 107.62 272.243 107.785 272.558 108.116C272.878 108.447 273.038 108.908 273.038 109.5C273.038 109.889 272.958 110.231 272.798 110.524C272.643 110.817 272.414 111.047 272.11 111.212C271.811 111.377 271.456 111.46 271.046 111.46C270.224 111.46 269.654 111.204 269.334 110.692C269.014 110.175 268.854 109.433 268.854 108.468C268.854 107.455 269.022 106.703 269.358 106.212C269.699 105.716 270.243 105.468 270.99 105.468C271.39 105.468 271.726 105.548 271.998 105.708C272.275 105.863 272.483 106.068 272.622 106.324C272.766 106.58 272.851 106.86 272.878 107.164H271.606ZM270.974 108.7C270.744 108.7 270.552 108.769 270.398 108.908C270.248 109.041 270.174 109.233 270.174 109.484C270.174 109.74 270.243 109.94 270.382 110.084C270.526 110.228 270.728 110.3 270.99 110.3C271.224 110.3 271.408 110.231 271.542 110.092C271.68 109.948 271.75 109.753 271.75 109.508C271.75 109.257 271.683 109.06 271.55 108.916C271.416 108.772 271.224 108.7 270.974 108.7ZM278.228 107.62C278.228 107.945 278.153 108.244 278.004 108.516C277.854 108.783 277.625 108.999 277.316 109.164C277.006 109.329 276.622 109.412 276.164 109.412H275.316V111.428H273.948V105.812H276.164C276.612 105.812 276.99 105.889 277.3 106.044C277.609 106.199 277.841 106.412 277.996 106.684C278.15 106.956 278.228 107.268 278.228 107.62ZM276.06 108.324C276.321 108.324 276.516 108.263 276.644 108.14C276.772 108.017 276.836 107.844 276.836 107.62C276.836 107.396 276.772 107.223 276.644 107.1C276.516 106.977 276.321 106.916 276.06 106.916H275.316V108.324H276.06Z"
      fill="white"
    />
    <defs>
      <clipPath id="clip0_1168_39262">
        <rect
          width="15.9999"
          height="272"
          fill="white"
          transform="translate(22.4517 5.7287)"
        />
      </clipPath>
      <clipPath id="clip1_1168_39262">
        <rect
          width="15.9999"
          height="272"
          fill="white"
          transform="translate(46.4515 5.7287)"
        />
      </clipPath>
      <clipPath id="clip2_1168_39262">
        <rect
          width="15.9999"
          height="260"
          fill="white"
          transform="translate(82.9761 5.7287)"
        />
      </clipPath>
      <clipPath id="clip3_1168_39262">
        <rect
          width="15.9999"
          height="260"
          fill="white"
          transform="translate(106.976 5.7287)"
        />
      </clipPath>
      <clipPath id="clip4_1168_39262">
        <rect
          width="15.9999"
          height="196.4"
          fill="white"
          transform="translate(143.5 5.7287)"
        />
      </clipPath>
      <clipPath id="clip5_1168_39262">
        <rect
          width="15.9999"
          height="196.4"
          fill="white"
          transform="translate(167.5 5.7287)"
        />
      </clipPath>
      <clipPath id="clip6_1168_39262">
        <rect
          width="15.9999"
          height="152"
          fill="white"
          transform="translate(204.025 5.7287)"
        />
      </clipPath>
      <clipPath id="clip7_1168_39262">
        <rect
          width="15.9999"
          height="152"
          fill="white"
          transform="translate(228.025 5.7287)"
        />
      </clipPath>
      <clipPath id="clip8_1168_39262">
        <rect
          width="15.9999"
          height="146.8"
          fill="white"
          transform="translate(264.549 5.7287)"
        />
      </clipPath>
      <clipPath id="clip9_1168_39262">
        <rect
          width="15.9999"
          height="146.8"
          fill="white"
          transform="translate(288.549 5.7287)"
        />
      </clipPath>
    </defs>
  </svg>
);
